<script setup lang="ts">
import type { TpgChangeEvent } from '@tpg/grammar-web';

export interface GrammarRadioButtonGroupProps {
  selectedValue?: string;
  size?: 'regular' | 'small';
  formAssociated?: boolean;
  name?: string;
}

const props = withDefaults(defineProps<GrammarRadioButtonGroupProps>(), {
  selectedValue: '',
  size: 'regular',
  formAssociated: true,
  name: '',
});
const emit = defineEmits(['input']);

function onInput(event: TpgChangeEvent<string>) {
  emit('input', event.value);
}
</script>

<template>
  <tpg-radio-button-group v-bind="props" @tpg-change="onInput">
    <slot />
  </tpg-radio-button-group>
</template>
